var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    {
      'overflow-auto': _vm.isCanvas,
      'scrollbar-photo': _vm.backgroundLuminance === 'light',
      'scrollbar-photo-dark': _vm.backgroundLuminance === 'dark',
    } ],attrs:{"id":"wish-list","dir":_vm.dir}},[_vm._l((_vm.currentPosts),function(post,index){return _c('surface-post',{key:post.cid,attrs:{"index":index,"post":post,"edit":_vm.inlinePostEdit}})}),_vm._v(" "),_c('div',{staticClass:"wish-sizer"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }